var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuyOnChair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1600 1200",
    style: {
      enableBackground: "new 0 0 1600 1200"
    },
    xmlSpace: "preserve",
    width: "1600px",
    height: "1200px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M497.2,978.6c91.6,0,183.2,0,274.8,0c91.3,0,182.6,0,273.8,0c51.6,0,103.3,0,154.9,0c1.9,0,1.9-3,0-3 c-91.6,0-183.2,0-274.8,0c-91.3,0-182.6,0-273.8,0c-51.6,0-103.3,0-154.9,0C495.3,975.6,495.3,978.6,497.2,978.6L497.2,978.6z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1219.2,916.4c-0.8,28.8,2.1,57.6,8.7,85.7c0.4,1.9,3.3,1.1,2.9-0.8c-6.5-27.8-9.4-56.3-8.5-84.9 C1222.2,914.5,1219.2,914.5,1219.2,916.4L1219.2,916.4z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1338.3,918.7c2.8,26.6,1.1,53.5-5,79.5c-0.4,1.9,2.4,2.7,2.9,0.8c6.2-26.3,8-53.4,5.1-80.3 C1341.1,916.8,1338.1,916.8,1338.3,918.7L1338.3,918.7z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1229.1,1004.9c34.6,8.8,71.2,7.6,105.1-3.6c1.8-0.6,1-3.5-0.8-2.9c-33.5,11-69.4,12.3-103.5,3.6 C1228,1001.6,1227.2,1004.5,1229.1,1004.9L1229.1,1004.9z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1220.6,917.8c38.9,8.3,79.2,8.1,118-0.5c1.9-0.4,1.1-3.3-0.8-2.9c-38.3,8.5-78.1,8.6-116.4,0.5 C1219.5,914.5,1218.7,917.4,1220.6,917.8L1220.6,917.8z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1244.3,918.9c-5.2-11.7-0.5-26,3.4-37.5c4-11.9,9.7-23.2,16.7-33.6c-0.8,0.1-1.6,0.2-2.4,0.3 c2.3,2.6,4.8,4.4,7.9,5.9c1.2,0.5,2.5-0.3,2.2-1.7c-1.2-5.4-3.3-10.7-0.9-16.1c1.7-3.8,4.1-7.6,6.1-11.2 c-0.7,0.2-1.4,0.4-2.1,0.5c2.1,1.3,4.2,2.5,6.3,3.8c1.4,0.9,2.6-0.8,2.1-2.1c-2.1-4.6-3.5-9.2-0.6-13.8c1.7-2.8,3.9-5.3,5.8-7.9 c4.2-5.6,8.6-11.2,13-16.7c8.4-10.5,17.1-20.7,26.1-30.7c-0.8-0.1-1.6-0.2-2.4-0.3c12.8,16.8,20.9,36.9,23.1,57.9 c1.1,10.1,0.8,20.5-1,30.5c-0.9,5.1-2.2,10.1-3.8,15c-0.3,1-0.7,2-1,2.9c-1.1,2.8-2.9,4-5.8,4.6c-2,0.4-3.1,0.1-4.8,1.4 c-0.8,0.6-1,1.6-0.3,2.4c2.2,2.3,3.1,2.7,2.3,5.8c-0.5,2-1.7,4.1-2.6,6.1c-1.8,4-3.8,7.9-5.9,11.7c-4.3,7.8-9.2,15.2-14.7,22.2 c-1.2,1.5,0.9,3.6,2.1,2.1c10.6-13.6,19-28.5,25.3-44.5c0.2-0.5,0-1.1-0.4-1.5c-1.3-1.3-2.6-2.7-4-4c-0.1,0.8-0.2,1.6-0.3,2.4 c2.3-1.6,4.9-0.5,7.3-1.5c1.9-0.7,2.9-2.1,3.7-3.9c2.2-4.7,3.6-10.1,4.8-15.1c2.5-11,3.3-22.3,2.5-33.5 c-1.7-22.6-10-44.5-23.8-62.5c-0.5-0.7-1.6-1.1-2.4-0.3c-11.1,12.3-21.8,25-32,38c-4.6,5.8-9.5,11.6-13.5,17.9 c-3.6,5.7-1.9,11.1,0.6,16.9c0.7-0.7,1.4-1.4,2.1-2.1c-2.1-1.3-4.2-2.5-6.3-3.8c-0.7-0.4-1.7-0.2-2.1,0.5 c-2.5,4.6-6.4,9.7-7.8,14.8c-1.2,4.5,1.3,10.4,2.3,14.8c0.7-0.6,1.5-1.1,2.2-1.7c-2.9-1.3-5.2-3-7.3-5.4 c-0.7-0.8-1.9-0.5-2.4,0.3c-7.8,11.6-13.9,24.3-18.1,37.7c-3.6,11.6-7.1,24.8-2,36.4C1242.5,922.1,1245.1,920.6,1244.3,918.9 L1244.3,918.9z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1325.7,780.8c-4,45.3-35,81.6-47.9,124.2c-0.6,1.9,2.3,2.6,2.9,0.8c12.9-42.9,44-79.3,48-125 C1328.9,778.8,1325.8,778.9,1325.7,780.8L1325.7,780.8z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1287.9,804.9c3.2,16.5,6.9,32.8,11.1,49c0.5,1.9,3.4,1.1,2.9-0.8c-4.2-16.2-7.9-32.6-11.1-49 C1290.5,802.2,1287.6,803,1287.9,804.9L1287.9,804.9z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1321.7,815.5c8.7-6.3,16.2-13.8,22.7-22.5c1.2-1.5-1.4-3-2.6-1.5c-6.1,8.2-13.3,15.4-21.6,21.4 C1318.7,814.1,1320.2,816.7,1321.7,815.5L1321.7,815.5z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1312.4,772.7c2.7,8.6,4.3,19.1,10.9,25.6c1.4,1.4,3.5-0.8,2.1-2.1c-6.1-6.1-7.7-16.4-10.2-24.3 C1314.7,770.1,1311.8,770.9,1312.4,772.7L1312.4,772.7z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1238.3,918.1c-6.1-4.8-9.8-11.5-12.9-18.5c-3.5-8.2-6.5-16.6-9.2-25.1c-5.1-16.3-8.8-33.1-11-50 c-4.5-35.4-0.9-71.2-5.2-106.7c-0.9,0.3-1.9,0.5-2.8,0.8c11.2,25.2,37.4,40.3,59.2,55.3c-0.2-0.7-0.4-1.4-0.5-2.1 c-3,4.3-6,8.6-9,12.9c-0.7,1,0.2,2.3,1.3,2.3c3.9,0,7.3-0.5,11-1.8c-0.6-0.2-1.1-0.5-1.7-0.7c3.7,5.7,7.4,11.4,11.1,17.1 c0.1-0.6,0.2-1.2,0.2-1.8c-1.8,1.7-3.3,3.6-4.8,5.7c-0.5,0.7,0,2.1,0.9,2.2c8.2,1.2,11.1,9,13.2,16c0.6,1.8,3.5,1.1,2.9-0.8 c-2.5-7.9-6.1-16.8-15.3-18.1c0.3,0.7,0.6,1.5,0.9,2.2c1.3-2,2.6-3.4,4.3-5c0.5-0.4,0.6-1.3,0.2-1.8c-3.7-5.7-7.4-11.4-11.1-17.1 c-0.3-0.5-1-0.9-1.7-0.7c-3.4,1.1-6.7,1.7-10.2,1.6c0.4,0.8,0.9,1.5,1.3,2.3c3-4.3,6-8.6,9-12.9c0.5-0.7,0.1-1.6-0.5-2.1 c-21.4-14.7-47.1-29.4-58.1-54.2c-0.6-1.3-3-0.7-2.8,0.8c4.4,36.8,0.5,74,5.7,110.7c2.5,17.7,6.6,35.1,12.3,52 c4.6,13.7,9.4,30.4,21.1,39.7C1237.7,921.4,1239.8,919.3,1238.3,918.1L1238.3,918.1z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1197.8,720.8c8.1,22.4,14.9,46,25.8,67.3c5.4,10.5,11.3,20.8,16.4,31.5c5.5,11.6,10.4,23.4,15.4,35.1 c0.7,1.8,3.3,0.2,2.6-1.5c-4.7-11.2-9.5-22.4-14.6-33.4c-5-10.8-10.8-21.1-16.4-31.6c-11.2-21.4-18.1-45.4-26.4-68.1 C1200,718.2,1197.1,719,1197.8,720.8L1197.8,720.8z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1201.6,796.8c10.8,1.3,22.6,1.9,30.8,10c1.4,1.4,3.5-0.8,2.1-2.1c-8.8-8.6-21.3-9.4-32.9-10.8 C1199.7,793.6,1199.7,796.6,1201.6,796.8L1201.6,796.8z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1230.5,756.3c-1.8,6.5-3,13.2-3.5,20c-0.4,5.8-1.1,12.6,0.9,18.2c0.6,1.8,3.5,1,2.9-0.8 c-1.9-5.3-1.2-11.9-0.8-17.5c0.5-6.5,1.7-12.9,3.4-19.2C1233.9,755.2,1231,754.4,1230.5,756.3L1230.5,756.3z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1208.4,851.3c7.8,0.2,15.3,0.3,22.9,2.4c7.5,2.1,14.9,4.3,22.4,6.5c1.9,0.5,2.7-2.4,0.8-2.9 c-8-2.3-15.9-4.8-24-6.9c-7.3-1.9-14.6-1.8-22.1-2C1206.5,848.2,1206.5,851.2,1208.4,851.3L1208.4,851.3z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1317.8,915.3c6.7-0.9,13.3-0.9,20,0c-0.3-0.7-0.6-1.5-0.9-2.2c-0.6,0.9-6.6,1-7.8,1.1 c-2.7,0.4-5.5,0.8-8.2,1.4c-0.4,0.1-3.1,0.4-3.2,0.7c0.2-0.5,4.2-0.4,4.8-0.4c2.9,0,5.8,0.3,8.7,0.5c0-1,0-2,0-3 c-2.5-0.1-4.7,0.2-7.2,0.9c-1.6,0.4-1.3,2.9,0.4,2.9c3.9,0,7.4-0.8,11.2-1.8c1.9-0.5,1.1-3.4-0.8-2.9c-3.4,0.9-6.8,1.7-10.4,1.7 c0.1,1,0.3,2,0.4,2.9c2.1-0.6,4.2-0.8,6.4-0.8c1.9,0,1.9-2.9,0-3c-4.4-0.2-10.8-1.8-14.8,0.7c-1.6,1-3.9,3.6-1.8,5.2 c0.9,0.7,1.9,0.3,3,0.2c3-0.6,5.9-1.3,8.9-1.8c3.5-0.6,10.5,0.3,12.9-3c0.5-0.7,0-2.1-0.9-2.2c-7-1-13.8-1-20.8-0.1 C1315.9,912.5,1315.9,915.5,1317.8,915.3L1317.8,915.3z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1221.9,917.2c1.4-0.4,2.8-0.7,4.2-0.8c0.7,0,1.3-0.1,2,0c0.3,0,1.7-0.1,1.8,0c-0.1-0.5-0.3-1-0.4-1.5 c0,0.1-0.1,0.2-0.1,0.2c0.6-0.3,1.2-0.7,1.8-1c-0.1,0-0.2,0-0.2,0c0.3,0.3,0.7,0.7,1,1c0-0.1,0-0.2-0.1-0.2 c-0.5-1.9-3.3-1.1-2.9,0.8c0,0.1,0,0.2,0.1,0.2c0.1,0.5,0.6,0.9,1,1c0.1,0,0.2,0,0.2,0c0.8,0.2,1.5-0.2,1.8-1 c0-0.1,0.1-0.2,0.1-0.2c0.2-0.5,0-1.1-0.4-1.5c-1.1-1.1-3.5-0.9-4.9-0.9c-2,0-4.1,0.4-6,0.9 C1219.3,914.8,1220.1,917.7,1221.9,917.2L1221.9,917.2z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1224.2,937.3c36.5,6.3,74.4,9.3,110.4-1.5c1.8-0.6,1.1-3.4-0.8-2.9c-35.4,10.6-72.8,7.7-108.8,1.5 C1223.1,934.1,1222.3,937,1224.2,937.3L1224.2,937.3z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1349.9,978.4c64.1,0,128.3,0,192.4,0c1.9,0,1.9-3,0-3c-64.1,0-128.3,0-192.4,0 C1347.9,975.4,1347.9,978.4,1349.9,978.4L1349.9,978.4z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1301.4,1042.7c60.4,0,120.9,0,181.3,0c1.9,0,1.9-3,0-3c-60.4,0-120.9,0-181.3,0 C1299.5,1039.7,1299.5,1042.7,1301.4,1042.7L1301.4,1042.7z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1328.9,1042.4c-7.2,6-14.4,11.9-21.5,17.9c-1.5,1.2,0.6,3.3,2.1,2.1c7.2-6,14.4-11.9,21.5-17.9 C1332.5,1043.3,1330.3,1041.1,1328.9,1042.4L1328.9,1042.4z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1308.3,1063.5c1.9,0,1.9-3,0-3C1306.4,1060.5,1306.4,1063.5,1308.3,1063.5L1308.3,1063.5z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1338.8,1060.5c-60.9,0-121.8,0-182.7,0c-1.9,0-1.9,3,0,3c60.9,0,121.8,0,182.7,0 C1340.7,1063.5,1340.7,1060.5,1338.8,1060.5L1338.8,1060.5z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1155.8,1091.5c10.8-9,21.9-17.6,33.3-25.9c1.5-1.1,0.1-3.7-1.5-2.6c-11.6,8.4-22.9,17.2-33.9,26.3 C1152.2,1090.6,1154.3,1092.7,1155.8,1091.5L1155.8,1091.5z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M245.4,1036.9c70.6,0,141.2,0,211.8,0c20,0,40,0,60,0c1.9,0,1.9-3,0-3c-70.6,0-141.2,0-211.8,0 c-20,0-40,0-60,0C243.5,1033.9,243.5,1036.9,245.4,1036.9L245.4,1036.9z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M282.3,1063c9.5-8.1,19.1-16.2,28.6-24.3c1.5-1.3-0.7-3.4-2.1-2.1c-9.5,8.1-19.1,16.2-28.6,24.3 C278.7,1062.1,280.9,1064.3,282.3,1063L282.3,1063z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M247.9,1065.9c65.6,0,131.2,0,196.8,0c1.9,0,1.9-3,0-3c-65.6,0-131.2,0-196.8,0 C246,1062.9,246,1065.9,247.9,1065.9L247.9,1065.9z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M421.8,1065.3c-7.5,8.4-15.2,16.6-23,24.8c-1.3,1.4,0.8,3.5,2.1,2.1c7.8-8.2,15.4-16.4,23-24.8 C425.3,1066,423.1,1063.9,421.8,1065.3L421.8,1065.3z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M370.6,1094.9c57.7,0,115.3,0,173,0c1.9,0,1.9-3,0-3c-57.7,0-115.3,0-173,0 C368.7,1091.9,368.7,1094.9,370.6,1094.9L370.6,1094.9z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M329.7,986.6c24.4,0,48.8,0,73.3,0c1.9,0,1.9-3,0-3c-24.4,0-48.8,0-73.3,0 C327.8,983.6,327.8,986.6,329.7,986.6L329.7,986.6z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M421.5,996.4c7.5,0,15.1,0,22.6,0c1.9,0,1.9-3,0-3c-7.5,0-15.1,0-22.6,0 C419.5,993.4,419.5,996.4,421.5,996.4L421.5,996.4z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M367.2,461.7c0,16.3,0,32.7,0,49c0,1.9,3,1.9,3,0c0-16.3,0-32.7,0-49C370.2,459.8,367.2,459.8,367.2,461.7 L367.2,461.7z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M316.9,513.1c40.2,0,80.4,0,120.6,0c1.9,0,1.9-3,0-3c-40.2,0-80.4,0-120.6,0 C315,510.1,315,513.1,316.9,513.1L316.9,513.1z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M401.1,514.5c0,12.6,0,25.1,0,37.7c0,1.9,3,1.9,3,0c0-12.6,0-25.1,0-37.7 C404.1,512.5,401.1,512.5,401.1,514.5L401.1,514.5z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M367.8,557.4c32,0,64.1,0,96.1,0c1.9,0,1.9-3,0-3c-32,0-64.1,0-96.1,0C365.8,554.4,365.8,557.4,367.8,557.4 L367.8,557.4z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1174.8,426.6c0,4,0,7.9,0,11.9c0,1.9,3,1.9,3,0c0-4,0-7.9,0-11.9C1177.8,424.7,1174.8,424.7,1174.8,426.6 L1174.8,426.6z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1177.2,429c68.8,0,137.6,0,206.4,0c1.9,0,1.9-3,0-3c-68.8,0-137.6,0-206.4,0 C1175.3,426,1175.3,429,1177.2,429L1177.2,429z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1179,440c68.2,0,136.4,0,204.5,0c1.9,0,1.9-3,0-3c-68.2,0-136.4,0-204.5,0C1177.1,437,1177.1,440,1179,440 L1179,440z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1383.1,426.6c-0.4,4.1-0.2,8.2,0.5,12.3c0.3,1.9,3.2,1.1,2.9-0.8c-0.7-3.8-0.8-7.7-0.4-11.5 C1386.3,424.7,1383.3,424.7,1383.1,426.6L1383.1,426.6z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1191.3,426.7c0-27.9,0-55.8,0-83.7c0-1.9-3-1.9-3,0c0,27.9,0,55.8,0,83.7 C1188.3,428.7,1191.3,428.7,1191.3,426.7L1191.3,426.7z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1191.3,343.5c8.5-3.4,17.5-2.9,25.4,1.8c1.7,1,3.2-1.6,1.5-2.6c-8.5-5-18.6-5.8-27.7-2.1 C1188.7,341.3,1189.5,344.2,1191.3,343.5L1191.3,343.5z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1216.2,344.6c0,26.8,0,53.7,0,80.5c0,1.9,3,1.9,3,0c0-26.8,0-53.7,0-80.5 C1219.2,342.7,1216.2,342.7,1216.2,344.6L1216.2,344.6z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1219.6,367c6.1-2.5,12.5-2.1,18.2,1.4c1.7,1,3.2-1.6,1.5-2.6c-6.3-3.8-13.7-4.5-20.5-1.7 C1217,364.8,1217.8,367.7,1219.6,367L1219.6,367z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1237.2,368.3c0,18.8,0,37.5,0,56.3c0,1.9,3,1.9,3,0c0-18.8,0-37.5,0-56.3 C1240.2,366.4,1237.2,366.4,1237.2,368.3L1237.2,368.3z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1191.7,366.5c8.5-1.9,16.9-1.3,25.1,1.6c1.8,0.6,2.6-2.3,0.8-2.9c-8.7-3.1-17.7-3.5-26.7-1.6 C1189.1,364,1189.9,366.9,1191.7,366.5L1191.7,366.5z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1217.5,401.2c6.4-1.7,12.8-1.9,19.3-0.5c1.9,0.4,2.7-2.5,0.8-2.9c-7-1.5-13.9-1.4-20.9,0.5 C1214.9,398.8,1215.6,401.7,1217.5,401.2L1217.5,401.2z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1275,425.7c0-5.6,0-11.2,0-16.8c0-1.9-3-1.9-3,0c0,5.6,0,11.2,0,16.8C1272,427.6,1275,427.6,1275,425.7 L1275,425.7z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1273.5,409.8c32.5,0,64.9,0,97.4,0c1.9,0,1.9-3,0-3c-32.5,0-64.9,0-97.4,0 C1271.5,406.8,1271.5,409.8,1273.5,409.8L1273.5,409.8z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1371.9,411.4c1.9,0,1.9-3,0-3C1369.9,408.4,1369.9,411.4,1371.9,411.4L1371.9,411.4z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1370.4,409.9c0,5.1,0,10.2,0,15.3c0,1.9,3,1.9,3,0c0-5.1,0-10.2,0-15.3C1373.4,408,1370.4,408,1370.4,409.9 L1370.4,409.9z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1293.9,407.8c0-5.3,0-10.5,0-15.8c0-1.9-3-1.9-3,0c0,5.3,0,10.5,0,15.8 C1290.9,409.7,1293.9,409.7,1293.9,407.8L1293.9,407.8z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1292.4,393c31.9,0,63.8,0,95.8,0c1.9,0,1.9-3,0-3c-31.9,0-63.8,0-95.8,0C1290.5,390,1290.5,393,1292.4,393 L1292.4,393z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1387.2,391.5c0,4.4,0,8.8,0,13.2c0,1.9,3,1.9,3,0c0-4.4,0-8.8,0-13.2 C1390.2,389.5,1387.2,389.5,1387.2,391.5L1387.2,391.5z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1369.8,410.3c5.8,0,11.6,0,17.4,0c1.9,0,1.9-3,0-3c-5.8,0-11.6,0-17.4,0 C1367.8,407.3,1367.8,410.3,1369.8,410.3L1369.8,410.3z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1387,404.8c-0.2,1.1-0.2,2.1,0.1,3.1c0.2,0.8,1.1,1.3,1.8,1c0.8-0.2,1.3-1.1,1-1.8 c-0.1-0.5-0.2-1.1-0.1-1.5c0.1-0.8-0.2-1.7-1-1.8C1388.1,403.6,1387.1,404,1387,404.8L1387,404.8z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1315.2,392.2c1.3,5.1,1.6,10.3,0.9,15.6c-0.2,1.9,2.8,1.9,3,0c0.7-5.5,0.3-11-1-16.4 C1317.6,389.6,1314.7,390.4,1315.2,392.2L1315.2,392.2z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1337.8,409.6c0.7,5,0.3,9.9-0.9,14.7c-0.5,1.9,2.4,2.7,2.9,0.8c1.4-5.4,1.7-10.8,0.9-16.3 C1340.5,406.9,1337.6,407.7,1337.8,409.6L1337.8,409.6z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1318.2,531.3c0,7.9,0,15.7,0,23.6c0,1.9,3,1.9,3,0c0-7.9,0-15.7,0-23.6 C1321.2,529.3,1318.2,529.3,1318.2,531.3L1318.2,531.3z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1295,555.3c20,0,40,0,60,0c1.9,0,1.9-3,0-3c-20,0-40,0-60,0C1293.1,552.3,1293.1,555.3,1295,555.3 L1295,555.3z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1260.9,218.9c0,18,0,36.1,0,54.1c0,1.9,3,1.9,3,0c0-18,0-36.1,0-54.1C1263.9,217,1260.9,217,1260.9,218.9 L1260.9,218.9z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1264.7,218.8c22.8,0,45.5,0,68.3,0c1.9,0,1.9-3,0-3c-22.8,0-45.5,0-68.3,0 C1262.8,215.8,1262.8,218.8,1264.7,218.8L1264.7,218.8z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1333.1,218.4c0,17.4,0,34.8,0,52.1c0,1.9,3,1.9,3,0c0-17.4,0-34.8,0-52.1 C1336.1,216.5,1333.1,216.5,1333.1,218.4L1333.1,218.4z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1262,274.7c24.2,0,48.4,0,72.6,0c1.9,0,1.9-3,0-3c-24.2,0-48.4,0-72.6,0 C1260.1,271.7,1260.1,274.7,1262,274.7L1262,274.7z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1267.6,225.1c0,13.7,0,27.3,0,41c0,1.9,3,1.9,3,0c0-13.7,0-27.3,0-41 C1270.6,223.2,1267.6,223.2,1267.6,225.1L1267.6,225.1z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1269.8,226.3c18.7,0,37.5,0,56.2,0c1.9,0,1.9-3,0-3c-18.7,0-37.5,0-56.2,0 C1267.9,223.3,1267.9,226.3,1269.8,226.3L1269.8,226.3z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1324.9,225.1c0,12.7,0,25.3,0,38c0,1.9,3,1.9,3,0c0-12.7,0-25.3,0-38 C1327.9,223.2,1324.9,223.2,1324.9,225.1L1324.9,225.1z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1269.8,267.6c18.6,0,37.2,0,55.9,0c1.9,0,1.9-3,0-3c-18.6,0-37.2,0-55.9,0 C1267.9,264.6,1267.9,267.6,1269.8,267.6L1269.8,267.6z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1305.2,249.6c-7.9-6,3.9-18.5,9.4-11c5.1,6.8-3.2,15-10.3,11.2c-1.7-0.9-3.2,1.7-1.5,2.6 c4.6,2.5,10.7,1.8,14-2.5c3.4-4.3,3-11.1-1.3-14.7c-4.5-3.7-10.9-1.2-14,3c-3.3,4.6-2.3,10.6,2.2,14 C1305.3,253.3,1306.7,250.7,1305.2,249.6L1305.2,249.6z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1295.7,264.4c-0.4-7.9,9.3-10.9,15.4-10.9c7.5,0,9.9,6.7,13,12.4c0.9,1.7,3.5,0.2,2.6-1.5 c-2.1-3.8-4.1-8.8-7.6-11.6c-3.2-2.5-7.2-2.4-11-2c-7,0.8-15.9,5.1-15.4,13.6C1292.8,266.3,1295.8,266.3,1295.7,264.4 L1295.7,264.4z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1271.1,257.2c2.2-4.1,10.3-2.5,13.3-0.9c3.1,1.7,4.9,4.5,5.7,7.9c0.4,1.9,3.3,1.1,2.9-0.8 c-1.2-5.2-4.8-9.3-10-11c-4.4-1.4-11.9-1.5-14.4,3.2C1267.6,257.4,1270.2,258.9,1271.1,257.2L1271.1,257.2z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1276.9,249.8c-3.3-0.1-2.5-5-1.1-6.7c1.8-2.2,5.4-2.5,7.5-0.4c1.7,1.6,2.2,4.6,0.8,6.5 c-1,1.4-2.5,1.7-4.1,1.7c-0.6,0-3.1,0.1-3.5-0.4c-1.1-1.6-3.7-0.1-2.6,1.5c1.2,1.8,3.7,1.9,5.7,1.9c2.4,0.1,4.7-0.5,6.4-2.3 c3.2-3.5,2.1-9.4-1.7-12c-4.1-2.7-9.8-1.2-11.9,3.2c-1.8,3.9-0.5,9.8,4.5,9.9C1278.9,252.9,1278.9,249.9,1276.9,249.8 L1276.9,249.8z",
    style: {
      fill: "#E8E8E8"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M664.9,484.7c4.7,3.8,10.5,2.2,14.9-1.5c6.2-5.1,9.3-13.8,10.5-21.5c3.1-19.6-4.8-38.2-7.9-57.2 c-5.6-35.3,9.8-73.1,38.4-94.3c13.9-10.4,36.8-21.5,31.4-42.8c-0.5-1.9-3.4-1.1-2.9,0.8c5.1,20.3-18.5,30.6-31.4,40.4 c-11.6,8.9-21,20.4-27.7,33.3c-6.6,12.5-10.6,26.4-11.7,40.5c-1.3,17.1,3.2,33,6.9,49.5c2.2,10,3.6,20.5,1.7,30.7 c-0.9,4.7-2.5,9.3-5,13.4c-2.8,4.4-9.5,11.2-15.1,6.7C665.6,481.4,663.4,483.5,664.9,484.7L664.9,484.7z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M751.1,266.2c-11.3,0.5-21.2-8.3-20.6-19.9c0.6-12.1,14.9-23.3,27-20.1c10.8,2.9,19.1,14.8,16.4,25.9 c-2.7,11.1-15.2,13.5-24.8,15.1c-1.9,0.3-1.1,3.2,0.8,2.9c12.4-2,26.8-6.4,27.6-21.4c0.6-12.2-10.3-25.4-22.8-25.9 c-13.2-0.6-26.5,10.2-27.2,23.6c-0.6,13.2,10.7,23.4,23.6,22.9C753,269.1,753,266.1,751.1,266.2L751.1,266.2z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M736.3,258.4c4.8-12.1,30.4-14.1,33.4,0.3c0.4,1.9,3.3,1.1,2.9-0.8c-3.7-17.6-33.4-15-39.2-0.3 C732.7,259.4,735.6,260.1,736.3,258.4L736.3,258.4z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M751.3,244.9c-2.1-1.5-2.9-4.4-1.5-6.6c1.6-2.7,5-3,7.6-1.6c2,1.1,2.4,3.6,1.2,5.5c-1.5,2.3-4.7,2.6-7.2,2 c-1.9-0.4-2.7,2.5-0.8,2.9c4,0.9,8.8,0,10.8-3.9c1.8-3.5,0.5-7.7-3.1-9.4c-4-1.8-8.8-1-11.1,2.9c-2.3,3.7-0.8,8.3,2.6,10.7 C751.4,248.7,752.9,246.1,751.3,244.9L751.3,244.9z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M793.7,214.1c10.5-27.8,40.7-42,68.8-43.9c18.6-1.3,37.2,1.6,55.4,5.1c17.2,3.4,35.1,8.8,52.7,8.2 c14.5-0.5,29.4-6.5,36.2-20c0.9-1.7-1.7-3.2-2.6-1.5c-7.9,15.6-26.1,19.6-42.2,18.3c-18.8-1.5-37.3-7.1-55.8-10.2 c-30-5-62-5.7-88.7,11.2c-12.1,7.7-21.7,18.5-26.8,32C790.1,215.1,793,215.9,793.7,214.1L793.7,214.1z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1018.9,161.8c26.4,0,52.9,0,79.3,0c1.9,0,1.9-3,0-3c-26.4,0-52.9,0-79.3,0 C1016.9,158.8,1016.9,161.8,1018.9,161.8L1018.9,161.8z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1017.8,158.6c-4.7-4.6,0.4-12.4,4.1-15.9c4.5-4.4,10.7-6.1,16.7-3.7c0.5,0.2,1.5-0.1,1.7-0.7 c3.6-8.4,12.1-14.5,21.4-14.1c9.7,0.4,17.9,7.7,20.3,16.9c0.2,0.9,1.4,1.4,2.2,0.9c4.4-2.7,8.9,0.5,10.7,4.6 c1.6,3.8,1.2,8.1,0.8,12.2c-0.2,1.9,2.8,1.9,3,0c0.6-6,1-13.1-3.8-17.7c-3.4-3.2-8.1-4.2-12.1-1.7c0.7,0.3,1.5,0.6,2.2,0.9 c-2.7-10-11.3-18-21.8-19c-10.8-1.1-21.2,5.6-25.4,15.5c0.6-0.2,1.1-0.5,1.7-0.7c-8-3.2-16.4,0.2-21.6,6.8 c-3.9,4.9-7.3,12.8-2,17.9C1017.1,162.1,1019.2,160,1017.8,158.6L1017.8,158.6z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1074.7,173.3c12.3-1.4,19.5,11.5,21.4,21.9c2,10.7,0.1,21.4-1,32.1c-1.7,16.1-0.6,35.5,14.7,44.9 c1.6,1,3.2-1.6,1.5-2.6c-20.9-12.8-12.2-41.3-11.4-60.9c0.6-14.9-5.3-40.6-25.2-38.4C1072.8,170.5,1072.8,173.5,1074.7,173.3 L1074.7,173.3z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1126.4,255.3c-9,22.7-17.9,45.4-26.9,68c-0.7,1.8,2.2,2.6,2.9,0.8c9-22.7,17.9-45.4,26.9-68 C1130,254.3,1127.1,253.6,1126.4,255.3L1126.4,255.3z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1127.8,257.2c15.6-0.8,31.1-0.4,46.6,1.4c-0.5-0.6-1-1.3-1.4-1.9c-7.4,23.7-13.4,47.7-18.2,72 c-0.4,1.9,2.5,2.7,2.9,0.8c4.8-24.3,10.9-48.3,18.2-72c0.3-1-0.5-1.8-1.4-1.9c-15.5-1.8-31-2.2-46.6-1.4 C1125.9,254.3,1125.9,257.3,1127.8,257.2L1127.8,257.2z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1100.2,326.2c9.2,0.4,18.3,0.9,27.5,1.5c8.9,0.5,18.4,0.3,26.8,3.7c1.8,0.7,2.6-2.2,0.8-2.9 c-8-3.3-17.1-3.1-25.6-3.6c-9.8-0.6-19.6-1.1-29.5-1.6C1098.3,323.1,1098.3,326.1,1100.2,326.2L1100.2,326.2z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1129.2,267.2c9.6,0.2,19.2,0.9,28.7,2.2c1.9,0.3,2.7-2.6,0.8-2.9c-9.8-1.4-19.6-2.2-29.5-2.4 C1127.2,264.1,1127.2,267.1,1129.2,267.2L1129.2,267.2z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1126.3,274c5.4-0.2,10.8-0.1,16.2,0.4c1.9,0.2,1.9-2.8,0-3c-5.4-0.5-10.8-0.7-16.2-0.4 C1124.4,271.1,1124.4,274.1,1126.3,274L1126.3,274z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1119.7,287.5c11.5-0.7,22.4-1.7,33.7,1.1c1.9,0.5,2.7-2.4,0.8-2.9c-11.6-2.8-22.7-1.9-34.5-1.2 C1117.7,284.6,1117.7,287.6,1119.7,287.5L1119.7,287.5z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1120.2,296.3c6.6-0.5,13.2-0.5,19.8,0.1c1.9,0.2,1.9-2.8,0-3c-6.6-0.6-13.2-0.6-19.8-0.1 C1118.3,293.5,1118.2,296.5,1120.2,296.3L1120.2,296.3z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1115,307.9c9-0.6,17.8-0.3,26.7,0.9c1.9,0.3,1.9-2.7,0-3c-8.9-1.2-17.8-1.5-26.7-0.9 C1113.1,305,1113.1,308,1115,307.9L1115,307.9z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M617.4,173.7c4,5.4,9.8,7.6,15.7,10.3c7,3.2,13.4,7.5,18.6,13.2c11.8,12.7,15.7,29.8,16,46.7 c0.7,31.7-10,64.9,4.4,94.9c0.8,1.7,3.4,0.2,2.6-1.5c-15.1-31.6-1.7-67-4.3-100.2c-1.1-14.4-5.2-28.5-14.5-39.7 c-4.4-5.3-9.8-9.9-15.8-13.3c-6.7-3.8-15.4-5.5-20.1-11.9C618.9,170.7,616.3,172.2,617.4,173.7L617.4,173.7z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M583.2,131.4c-2.6-3.3-2.4-5.6,0.6-6.9c1.3-0.7,2.6-1.2,4.1-1.5c1.9-0.4,4-0.5,6-0.4 c6,0.3,12.1,1.9,11.8,9.2c-0.3,8.6-1.9,17.1-4,25.4c-2.2,8.5-4.9,16.8-7.8,25.1c-0.6,1.8-1.1,3.9-2,5.6c-1.8,3.1-4.6,3-7.6,3 c-3.7,0-8.4,0.5-12-0.5c-4-1.1-4.9-5.1-1-7.7c1.8-1.2,4.3-1.4,6.4-1.4c2.7,0,5.1,0.6,7.4-1.2c4.4-3.4,5.1-12.6,6.1-17.5 c1.5-7.1,4-15.8,3.5-23c-0.4-5.5-5.8-5.7-9.7-8c-1.7-1-3.2,1.6-1.5,2.6c3.1,1.8,7.6,2,8.2,6.1c0.7,4.8-1.3,11.3-2.2,16.1 c-0.9,4.6-1.9,9.2-3.1,13.7c-0.9,3.4-1.3,7.5-5.8,8.4c-1.8,0.4-4-0.2-5.9,0.1c-4.8,0.7-9.5,4.1-8.8,9.5c0.9,6.8,9,5.6,14,5.8 c6.2,0.2,12.4,1.1,15.2-5.5c3.5-8.2,6-17.2,8.4-25.7c2.5-8.8,4.4-17.9,5.1-27c0.6-7.1,0.9-12.8-7-14.7 c-6.9-1.7-16.4-2.5-21.8,3.1c-3.6,3.7-2.7,11,3.5,10.5C585.1,134.2,585.1,131.2,583.2,131.4L583.2,131.4z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M571.1,142.1c-0.1-0.1-0.2-0.2-0.3-0.3c-0.4-0.4-1-0.5-1.5-0.4c-2.9,1-4,5.7-4.8,8.3 c-1.4,4.8-1.7,9.7-1,14.7c0.2,1.9,3.2,1.9,3,0c-0.4-3.5-0.5-6.9,0.1-10.4c0.3-1.8,3.4-8.8,2.3-9.8 C570.3,145.6,572.4,143.5,571.1,142.1L571.1,142.1z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M561,131.1c-9.2,11.7-15.1,25.8-11.2,40.8c0.5,1.9,3.4,1.1,2.9-0.8c-3.6-13.8,2-27.1,10.4-37.9 C564.3,131.7,562.2,129.6,561,131.1L561,131.1z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M548.4,117.6c-15.3,20.1-22.5,45.5-19.9,70.7c0.2,1.9,3.2,1.9,3,0c-2.5-24.7,4.4-49.4,19.5-69.2 C552.1,117.6,549.5,116.1,548.4,117.6L548.4,117.6z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M527.1,219.8c-7.7,3.7-14.9,8.8-20.6,15.2c-5.8,6.6-7.6,13.7-8.5,22.3c-2,19.7-9.3,41.3-29.1,49.6 c-1.8,0.7-1,3.6,0.8,2.9c15.8-6.6,25-21.6,28.9-37.8c2.3-9.7,1.2-21.2,6.3-29.9c5.2-8.9,14.6-15.4,23.7-19.8 C530.4,221.6,528.9,219,527.1,219.8L527.1,219.8z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M426.6,360c-6.6,0.2-14.1-2.6-16.5-9.4c-2.8-8,3.2-15.8,9.6-19.9c12.4-8,29.1-11.1,43.5-11.3 c7.3-0.1,15.6,0,22,3.9c8.2,5,9.6,14.4,3.2,21.5c-9.7,10.8-26.4,11.9-39.8,12.9c-1.9,0.1-1.9,3.1,0,3c13.4-1,28.4-2.2,39.2-11.2 c9.9-8.2,10.6-21.8-1-28.9c-12-7.3-30.3-4.9-43.3-2.1c-12.5,2.7-29.6,7.6-35.2,20.5c-5.8,13.2,5.3,24.2,18.5,23.8 C428.6,362.9,428.6,359.9,426.6,360L426.6,360z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M426.1,361.2c-2.5,4-4.9,8-7.4,11.9c-0.8,1.3,0.8,2.7,2.1,2.1c6.1-3.3,12.7-5.4,18.9-8.3 c3.4-1.5,6.7-3.3,9.9-5.3c1.1-0.7,2.4-1.1,2.7-2.5c0.2-0.7-0.2-1.7-1-1.8c-0.1,0-0.2,0-0.3-0.1c-0.7-0.1-1.7,0.2-1.8,1 c0,0.1,0,0.1,0,0.2c-0.4,1.9,2.5,2.7,2.9,0.8c0-0.1,0-0.1,0-0.2c-0.6,0.3-1.2,0.7-1.8,1c0.1,0,0.2,0,0.3,0.1 c-0.3-0.6-0.7-1.2-1-1.8c-0.3,1-5.9,3.3-7.1,4c-3,1.6-6.1,2.9-9.3,4.2c-4.7,1.9-9.3,3.7-13.7,6.1c0.7,0.7,1.4,1.4,2.1,2.1 c2.5-4,4.9-8,7.4-11.9C429.7,361.1,427.1,359.6,426.1,361.2L426.1,361.2z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M429.4,343.9c-0.1-0.2-0.1-0.6,0.2-0.6c0.8,0-0.1,1-0.2,1.1c-0.5,0.3-2.2,0.7-2.1-0.3 c0.1-1.2,2.4-2.5,2.8-0.7c0.1,0.5-0.3,1.1-0.8,1.2c-0.3,0.1-0.5,0.1-0.7-0.1c-0.1-0.1-0.3-0.2-0.1-0.2c1.9,0.1,1.9-2.9,0-3 c-2-0.2-3.5,1.9-3,3.8c0.5,1.9,2.7,2.9,4.5,2.4c1.8-0.5,3.2-2.1,3.2-4c0-1.9-1.5-3.5-3.2-3.9c-3.7-0.9-7.6,4.5-4.4,7.2 c2.6,2.2,7.8,0.2,7.5-3.5c-0.2-2-2.4-3.6-4.4-2.9c-2,0.7-2.8,3.2-1.8,5C427.7,347.1,430.3,345.6,429.4,343.9L429.4,343.9z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M451.5,341.2c-0.1-0.6-0.4-1.4,0.2-1.9c0.3-0.3,0.8-0.3,1.2-0.3c1,0.2,0.8,1.3,0.1,1.8 c-0.4,0.3-0.8,0.3-1.1-0.1c-0.3-0.4-0.2-0.5,0.1-0.7c0.2-0.1-0.4,0,0.1-0.1c1.2-0.2-0.8,1.2-0.5,0.2c-0.6,1.9,2.3,2.6,2.9,0.8 c0.5-1.8-1.2-3.6-3-3.3c-2.1,0.4-2.6,2.9-1.3,4.4c1.2,1.4,3.4,1.1,4.3-0.5c0.9-1.6,0.3-3.7-1.5-4.3c-1.8-0.6-3.8,0.5-4.2,2.3 c-0.5,2,0.9,4,2.9,4.5c3.6,0.8,6.6-4.1,4-6.8c-1.3-1.3-3.4-1.4-5-0.7c-2.2,1.1-2.3,3.4-1.9,5.5 C448.9,343.9,451.8,343.1,451.5,341.2L451.5,341.2z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M473.7,334.5c0.4,0,0.8,0.1,1.3,0.1c0,0,0-0.1,0-0.1c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.2,0.4-0.4,0.6-0.5 c0.5-0.2,1-0.2,1.3,0.3c0.4,0.8-0.3,2.3-1.3,1.7c-0.6-0.4-0.7-1.4,0.2-1.2c0.2,0,0.3,0.1,0.4,0.2c0,0,0,0.2,0,0 c0-0.2,0,0.1-0.1,0.1c-0.3,0.2-0.4,0.4-0.7,0.2c-0.7-0.5-1.7-0.1-2.1,0.5c-0.4,0.8-0.1,1.6,0.5,2.1c2.9,2.1,6.8-2.1,4.5-4.9 c-2.1-2.5-6.6-0.9-6.4,2.4c0.1,1.7,1.4,3.2,3,3.6c1.6,0.4,3.3-0.4,4.2-1.8c2-3.1-0.8-7.4-4.5-6.2c-1.7,0.6-3.2,2.3-3,4.2 c0.2,2.1,3.2,3.2,4.3,1.1C477.1,334.3,474.6,332.8,473.7,334.5L473.7,334.5z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M534.1,247.3c12.3-6.8,23-15.8,31.9-26.7c1.2-1.5-0.9-3.6-2.1-2.1c-8.7,10.7-19.2,19.5-31.3,26.2 C530.9,245.6,532.4,248.2,534.1,247.3L534.1,247.3z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M683.7,249.9c-2.2,12.6-3.1,25.3-2.5,38.1c0.1,1.9,3.1,1.9,3,0c-0.6-12.5,0.2-25,2.4-37.3 C686.9,248.8,684,248,683.7,249.9L683.7,249.9z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M668.4,542.2c0-15.3,7.2-29.8,19.5-39c1.5-1.1,0-3.7-1.5-2.6c-13.2,9.8-20.9,25.1-20.9,41.6 C665.4,544.1,668.4,544.1,668.4,542.2L668.4,542.2z",
    style: {
      fill: "#E8E8E8"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "chair"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M835.9,946c1.6,14.4,4.1,30.2,8.1,47.3c5.4,23.1,12.3,43.3,19.2,60.3c-1.9,1.7-7.6,6.2-16,6.8 c-5.3,0.4-9.5-0.9-11.9-1.8c-3.6-12.5-7.1-25.5-10.3-39c-6.6-27.8-11.4-54.3-14.9-79C818.8,942.4,827.4,944.2,835.9,946z",
    style: {
      fill: "#191919"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.4,936.6c-1.3,14.3-3.5,30.2-7.2,47.3c-5.2,24.2-12.1,45.2-19.1,62.9c1,0.9,6.7,6.3,15.5,5.9 c7.6-0.3,12.5-4.8,13.7-5.9c2.3-12.1,4.5-24.3,6.7-36.5c4.8-26.7,9.1-53,13.2-79C1075.6,933,1068,934.8,1060.4,936.6z",
    style: {
      fill: "#191919"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.6,896.7c2.3,15.3,5,31.1,8.1,47.3c4.5,23.5,9.6,45.9,15,67.1c-2.3,1.4-6.9,3.7-13.2,4.1 c-5.3,0.3-9.5-0.9-11.9-1.8c-3-14.2-5.9-28.6-8.8-43c-5.3-26.7-10.2-53-14.9-79C864.5,893.1,873,894.9,881.6,896.7z",
    style: {
      fill: "#191919"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.7,893.7c-2.7,15.1-5.1,30.9-7.2,47.3c-2.9,22.6-4.9,44.2-6.1,64.8c1.7,1.1,5.7,3.4,11.4,3.7 c6.1,0.2,10.6-2.2,12.3-3.2c-1-11.8-1.4-24.9-0.8-38.9c1.2-31.1,6.9-57.9,13.2-79C1037.9,890.1,1030.3,891.9,1022.7,893.7z",
    style: {
      fill: "#191919"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.4,559.1c17.5,31.2,4,65.7-28.8,151.4c-15.8,41.2-44.7,116.9-85.5,224.8 c-40.1,14.6-106.5,32.6-188.6,26.9c-47.7-3.3-87.7-13.6-118-24.2c-4.5-8.1-20.1-38.4-8.4-67.8c6.5-16.3,19.6-28,47.4-41.8 c27.4-13.6,75.7-32.7,145.9-36.2c-27.5-136.9,19.6-249.1,92.9-275C1105.4,500.3,1176.3,516.2,1200.4,559.1z",
    style: {
      fill: "#FFFFFF",
      stroke: "#191919",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1194,570.4c-29,36.7-35.6,86-46.7,130.1c-11.9,47.2-25.6,94.3-46.1,138.6c-11.3,24.3-24.6,47.7-40.5,69.3 c-1.1,1.6,1.5,3.1,2.6,1.5c27.9-38,47.6-81.1,62.8-125.5c15.4-45.2,25.6-91.8,37.6-137.9c6.8-26.2,15.5-52.4,32.5-73.9 C1197.3,571,1195.2,568.9,1194,570.4L1194,570.4z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M780.1,916.3c66.7,24.5,139.4,31.7,209.6,20.8c20.1-3.1,40-7.7,59.5-13.7c1.8-0.6,1.1-3.5-0.8-2.9 c-68,21-141,24.2-210.6,9.4c-19.3-4.1-38.4-9.7-56.9-16.5C779.1,912.7,778.3,915.6,780.1,916.3L780.1,916.3z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1014.9,837.7c16.8,5.5,31.1,16.6,40.7,31.6c1,1.6,3.6,0.1,2.6-1.5c-10-15.6-24.9-27.2-42.5-33 C1013.8,834.2,1013,837.1,1014.9,837.7L1014.9,837.7z",
    style: {
      fill: "#191919"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "leg_r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M714.1,967.2c8,12,16,24.1,23.9,36.1c-51.2,46-57.8,59.1-54,62.3c7.6,6.3,62.1-21.7,67.7-24.6 c20.3-10.4,35.6-20.5,45.8-27.7c-3.6-9.8-8.4-20.8-15-32.4c-8.7-15.3-18.3-28.2-27.4-38.7C741.4,950.4,727.7,958.8,714.1,967.2z",
    style: {
      fill: "#191919"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.3,731.5c3.6,7.8,7.4,18.9,8,32.3c0.9,20.2-5.7,36.3-10.7,45.6c-2.7,3.5-7.5,9.3-14.6,15.6 c0,0-16.1,14.2-41.7,25.1c-26.1,11.2-102,24.7-205.1,27.3c3,12.8,8.4,28.5,18,45.4c5.3,9.3,11.1,17.5,16.8,24.6 c-3.8,5-14.6,17.7-36.1,25.7c-20.7,7.7-39.7,6.8-47.2,6.2c-10.8-9.9-21.9-21.7-32.2-35.8c-30.3-41.7-37.4-82-38.7-107.9 c7.5-5.4,18.5-12.8,32.9-20.7c30-16.5,57.5-25.5,80.1-32.2c38.9-11.4,76.1-19.3,161.7-33.8C931.3,744.4,968.4,738.2,1013.3,731.5z",
    style: {
      fill: "#FFFFFF",
      stroke: "#191919",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.3,748.7c-2.9,19.1-11.1,43.9-36.5,59.3c-24.7,15-45.4,8.9-94.9,20.9c-35.6,8.6-82.7,20-95.8,45.3 c-13.7,26.6,12.2,64.1,57.5,94.9c3.8-0.5,8.6-1.5,13.7-3.5c13.1-5.2,19.5-13.7,21.9-17.4c-5.8-7-11.8-15.1-17.3-24.4 c-10.4-17.4-16-33.6-19.2-46.7c53-2.2,97.5-6.8,131.3-11.2c40.7-5.3,68.9-10.6,95.8-25.8c22.5-12.7,31.5-25.2,34.7-30 c9.7-14.7,10.5-28.1,10.9-35.6c1-18.3-5-33.2-10-42.6C979.7,737.5,949,743.1,918.3,748.7z",
    style: {
      opacity: 0.19,
      fill: "#6C6D6D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.4,734c-2,18.6-9.1,48-37.4,71.2c-17.4,14.3-36.1,20.7-109.5,40.5c-32.4,8.7-71.6,19-116.2,30.2 c56.7-0.6,102.8-5.3,135.9-9.8c34.3-4.7,51.1-8.8,68.5-16.3c16.5-7.1,49.8-21.5,63.4-51.8C1029.2,768.6,1016,742.2,1011.4,734z",
    style: {
      opacity: 0.19,
      fill: "#6C6D6D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.6,877.4c-0.4,13.2,0.2,28.3,2.7,44.9c2.4,16.4,6.3,31.1,10.5,43.9c3.4-2,7.3-4.7,11.1-8 c4.6-4,8-7.8,10.5-11.1c-5.8-7.6-11.7-16.4-17.2-26.3C757.3,904.8,752,890,748.6,877.4z",
    style: {
      opacity: 0.22,
      fill: "#6C6D6D"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "leg_l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M744,1024.6c7.7,15.1,15.3,30.2,23,45.4c-49.2,57.8-55.6,74.2-51.9,78.2c7.3,8,59.7-27.3,65.1-30.9 c19.5-13.1,34.3-25.8,44.1-34.8c-3.5-12.3-8.1-26.1-14.5-40.8c-8.3-19.2-17.6-35.4-26.3-48.7C770.3,1003.6,757.1,1014.1,744,1024.6 z",
    style: {
      fill: "#191919"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.6,728.4c3.5,9.9,7.1,23.7,7.7,40.6c0.9,25.4-5.5,45.6-10.3,57.3c-2.6,4.4-7.2,11.7-14,19.7 c0,0-15.4,17.9-40,31.6c-25.1,14-98.1,31.1-197.1,34.3c2.9,16.1,8,35.8,17.3,57c5.1,11.7,10.7,22,16.2,30.9 c-3.6,6.3-14,22.2-34.7,32.3c-19.9,9.7-38.1,8.6-45.4,7.7c-10.4-12.4-21.1-27.3-30.9-45c-29.2-52.4-36-103.1-37.2-135.6 c7.2-6.7,17.8-16.1,31.6-26c28.9-20.7,55.2-32.1,77-40.5c37.3-14.3,73.2-24.2,155.5-42.5C952.7,744.5,988.5,736.8,1031.6,728.4z",
    style: {
      fill: "#FFFFFF",
      stroke: "#191919",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.3,750c-2.8,24-10.7,55.1-35.1,74.5c-23.7,18.9-43.7,11.2-91.2,26.3c-34.2,10.8-79.5,25.2-92.1,57 c-13.2,33.4,11.7,80.6,55.2,119.2c3.7-0.6,8.3-1.9,13.2-4.4c12.6-6.5,18.7-17.2,21-21.9c-5.6-8.8-11.4-19-16.7-30.7 c-10-21.9-15.4-42.2-18.4-58.7c51-2.8,93.7-8.5,126.3-14c39.2-6.6,66.2-13.3,92.1-32.4c21.6-16,30.3-31.7,33.3-37.7 c9.3-18.5,10.1-35.3,10.5-44.7c0.9-23-4.8-41.7-9.6-53.5C999.3,735.9,969.8,742.9,940.3,750z",
    style: {
      opacity: 0.19,
      fill: "#6C6D6D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.7,731.5c-1.9,23.3-8.7,60.3-35.9,89.5c-16.8,18-34.7,26-105.2,50.9c-31.2,11-68.8,23.9-111.7,38 c54.5-0.8,98.9-6.6,130.7-12.3c33-5.9,49.2-11,65.8-20.4c15.9-9,47.8-27,61-65.2C1046.9,775,1034.2,741.9,1029.7,731.5z",
    style: {
      opacity: 0.19,
      fill: "#6C6D6D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.2,911.8c-0.4,16.6,0.2,35.6,2.6,56.4c2.4,20.7,6,39.1,10.1,55.1c3.3-2.6,7-5.9,10.7-10.1 c4.4-5,7.7-9.8,10.1-13.9c-5.6-9.6-11.3-20.6-16.5-33.1C785.6,946.2,780.4,927.5,777.2,911.8z",
    style: {
      opacity: 0.22,
      fill: "#6C6D6D"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand_r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M738.3,573c-1.9-0.9-5.7-2.6-5.6-4.5c0.2-3.1,10.5-5.2,18.2-5.1c5.2,0,14.8,1.1,26,8.9 C766.4,575.6,750.9,578.6,738.3,573z",
    style: {
      fill: "#FFFFFF",
      stroke: "#191919",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.8,443.3c-19-2.5-36.1,26-37.7,28.6c-5.8,9.9-6.5,16.5-10.5,34.6c-9.7,44.1-14.9,66.5-29.3,80 c-13,12.1-28.2,15-32.2,15.6c-17.1,2.7-32.6-3.7-62.8-16.6c-25.5-10.9-28.6-14.9-42.5-16.5c-7.1-0.8-27.8-3.1-41.5,10.2 c-8.8,8.5-12.7,22.1-9.5,24.9c4.1,3.6,20.9-9.1,21.1-8.8c0.1,0.2-5,2.6-9.2,7.8c-2.1,2.5-5.7,7.9-4.4,9.3 c2.3,2.8,16.4-14.2,31.9-11.2c10.6,2,12.6,11.6,24.9,13.4c7.2,1.1,13.5-1.1,17.5-3c7,7.6,18.4,18.4,34.9,27.2 c9.8,5.2,44.4,23.1,86.7,12.7c44.9-11,67.5-46.1,74.6-57.1c4-6.3,33.4-53.3,19.2-106C1007.5,479.9,998.4,445.9,978.8,443.3z",
    style: {
      fill: "#FFFFFF",
      stroke: "#191919",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.8,443.6c-6.5,3.4,6.1,27,4.5,60.8c-1.5,32.5-15.4,56.5-21.6,67.5c-8.4,14.7-19.5,33.9-41.6,46.4 c-29.7,16.8-66.5,14.3-92.7,2.9c-7.8-3.4-15.7-14.4-32.9-21.1c-7.5-2.9-13.4-4.1-20.3-5.5c-16.9-3.3-31.9-6.3-45.8,0.7 c-6.6,3.4-12.1,8.6-11.7,9.3c0.4,0.7,8.1-3.2,14.9-6.9c-8.2,10.9-9.5,14-8.9,14.6c0.7,0.6,3.2-1.7,9.6-5.3c6.9-3.8,11.9-6.5,18-6 c3.1,0.3,5.5,1.3,6.9,1.9c5.5,2.4,6.8,5.2,12.3,8c3.4,1.7,6.2,2.4,7.7,2.7c3.2,0.7,9.8,1.6,18.5-1.5c7.6,8,42.5,43.4,93.6,42.7 c26.3-0.4,45.6-10.2,53.2-14.1c41.7-21.7,58.3-60.2,62.5-70.8c13-32.8,17.6-81.4-6.2-111.9C991.1,450.6,981.3,441.3,976.8,443.6z",
    style: {
      opacity: 0.25,
      fill: "#6C6D6D"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M714.6,604.1c3.9-5.8,9-10.4,15.1-13.7c1.3-0.7,0.1-2.6-1.1-1.9c-6.4,3.5-11.8,8.4-15.9,14.5 C711.8,604.2,713.8,605.3,714.6,604.1L714.6,604.1z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M715.8,591.2c3.9-6.1,10.2-9.3,16.5-12.4c1.3-0.6,0.2-2.6-1.1-1.9c-6.7,3.2-13.3,6.7-17.4,13.2 C713.1,591.3,715,592.4,715.8,591.2L715.8,591.2z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1005.5,479.6c-1.5,10.1-4.2,24.7-9,41.9c-9.4,34-17.9,64.6-40.1,88.9c-27.5,30-64.8,38.2-86.2,40.7 c15.9,3.7,28.4,3,36.3,1.9c60-8.4,92.4-72.9,101.2-101.1c1.5-5,4.7-15.3,5.1-29.4C1013.5,503.7,1008.9,488.6,1005.5,479.6z",
    style: {
      opacity: 0.29,
      fill: "#6C6D6D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.2,600c5.7,2.8,13.5,5.9,23.1,7.7c7.6,1.4,14.4,1.7,19.8,1.5c-13.7,7.3-20.8,6.4-24.8,4 c-2.5-1.5-5.3-4.5-13-9.8C757.2,601.9,755.4,600.7,754.2,600z",
    style: {
      opacity: 0.26,
      fill: "#6C6D6D"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "table"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M552,764.4c0,48,0,96.1,0,144.1c0,5.8,9,5.8,9,0c0-48,0-96.1,0-144.1C561,758.7,552,758.6,552,764.4 L552,764.4z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M715.6,762.5c0,7.7,0,15.4,0,23.1c0,5.8,9,5.8,9,0c0-7.7,0-15.4,0-23.1C724.6,756.7,715.6,756.7,715.6,762.5 L715.6,762.5z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M427.8,758.5c48.5-45.7,97-91.5,145.6-137.2c78.5,1.4,156.9,2.8,235.4,4.2c-12.8,44.4-25.6,88.7-38.4,133.1 C656.2,758.5,542,758.5,427.8,758.5z",
    style: {
      fill: "#FFFFFF",
      stroke: "#191919",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M430.7,763.7c87.7,0,175.3,0,263,0c24.6,0,49.1,0,73.7,0c5.8,0,5.8-9,0-9c-87.7,0-175.3,0-263,0 c-24.6,0-49.1,0-73.7,0C424.9,754.7,424.9,763.7,430.7,763.7L430.7,763.7z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M456.4,762.2c0,99.5,0,199,0,298.4c0,27.9,0,55.7,0,83.6c0,5.8,9,5.8,9,0c0-99.5,0-199,0-298.4 c0-27.9,0-55.7,0-83.6C465.4,756.4,456.4,756.4,456.4,762.2L456.4,762.2z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M730.7,762.2c0,99.5,0,199,0,298.4c0,27.9,0,55.7,0,83.6c0,5.8,9,5.8,9,0c0-99.5,0-199,0-298.4 c0-27.9,0-55.7,0-83.6C739.7,756.4,730.7,756.4,730.7,762.2L730.7,762.2z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M460.9,947.9c70.6,0,141.2,0,211.8,0c20,0,40,0,60,0c5.8,0,5.8-9,0-9c-70.6,0-141.2,0-211.8,0 c-20,0-40,0-60,0C455.1,938.9,455.1,947.9,460.9,947.9L460.9,947.9z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M807.6,625.5c-11.4,44.5-24.5,88.6-39.5,132c-1.3,3.7,4.5,5.2,5.8,1.6c15-43.5,28.1-87.5,39.5-132 C814.3,623.4,808.6,621.8,807.6,625.5L807.6,625.5z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M328.8,1154c53.1,0,106.1,0,159.2,0c5.8,0,5.8-9,0-9c-53.1,0-106.1,0-159.2,0C323,1145,323,1154,328.8,1154 L328.8,1154z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M510.3,1152c12.2,0,24.5,0,36.7,0c5.8,0,5.8-9,0-9c-12.2,0-24.5,0-36.7,0C504.5,1143,504.5,1152,510.3,1152 L510.3,1152z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M669.5,1153.3c47.8,0,95.6,0,143.5,0c5.8,0,5.8-9,0-9c-47.8,0-95.6,0-143.5,0 C663.7,1144.3,663.7,1153.3,669.5,1153.3L669.5,1153.3z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M845.7,1150.1c8.5,0,17,0,25.6,0c5.8,0,5.8-9,0-9c-8.5,0-17,0-25.6,0 C839.9,1141.1,839.9,1150.1,845.7,1150.1L845.7,1150.1z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M280.6,1122.3c20.7,0,41.4,0,62,0c5.8,0,5.8-9,0-9c-20.7,0-41.4,0-62,0 C274.8,1113.3,274.8,1122.3,280.6,1122.3L280.6,1122.3z",
    style: {
      fill: "#161616"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "laptop"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M718,739.6c-61.7-1.6-123.5-3.1-185.2-4.7c36.6-35,73.1-70.1,109.7-105.1c42.2,2.2,84.5,4.4,126.7,6.6 C752.1,670.9,735.1,705.2,718,739.6z",
    style: {
      fill: "#FFFFFF",
      stroke: "#191919",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.4,629.1c-35.9,34.7-71.8,69.5-107.7,104.2c-1.6-55.6-3.3-111.3-4.9-166.9c36.4-23,72.8-46,109.2-69 C638,541.3,639.2,585.2,640.4,629.1z",
    style: {
      fill: "#FFFFFF",
      stroke: "#191919",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M531.1,571.7c2.9,49.5,4.8,99.1,5.8,148.7c0,1,1.5,1,1.5,0c-1-49.6-2.9-99.2-5.8-148.7 C532.5,570.8,531,570.8,531.1,571.7L531.1,571.7z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M531.9,571.9c33.5-21.8,67-43.6,100.5-65.4c0.8-0.5,0.1-1.8-0.8-1.3c-33.5,21.8-67,43.6-100.5,65.4 C530.3,571.2,531,572.5,531.9,571.9L531.9,571.9z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M632,506.4c-0.1,39.9,1.1,79.9,3.7,119.7c0.1,1,1.6,1,1.5,0c-2.5-39.9-3.8-79.8-3.7-119.7 C633.5,505.5,632,505.5,632,506.4L632,506.4z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M537.9,722.5c32.8-31.7,65.7-63.4,98.5-95c0.7-0.7-0.4-1.7-1.1-1.1c-32.8,31.7-65.7,63.4-98.5,95 C536.2,722.1,537.2,723.2,537.9,722.5L537.9,722.5z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M689.8,705.5c6.1-9.7,12.2-19.5,18.1-29.4c0.5-0.8-0.8-1.6-1.3-0.8c-5.9,9.9-12,19.7-18.1,29.4 C687.9,705.5,689.2,706.3,689.8,705.5L689.8,705.5z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M707.5,675.8c7.9,0.3,15.8,0.3,23.7-0.1c1,0,1-1.5,0-1.5c-7.9,0.3-15.8,0.3-23.7,0.1 C706.5,674.3,706.5,675.8,707.5,675.8L707.5,675.8z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M730.2,675.3c-4.5,9.8-9.1,19.6-13.7,29.4c-0.4,0.9,0.9,1.6,1.3,0.8c4.6-9.8,9.2-19.6,13.7-29.4 C731.9,675.1,730.6,674.4,730.2,675.3L730.2,675.3z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M689.3,706.3c8.8,1.3,18.1,0.7,27,0.3c1,0,1-1.5,0-1.5c-8.7,0.4-17.9,1-26.6-0.2 C688.7,704.7,688.3,706.2,689.3,706.3L689.3,706.3z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M722.1,675.4c-4,10-8.6,19.7-13.8,29.1c-0.5,0.8,0.8,1.6,1.3,0.8c5.2-9.6,9.9-19.4,14-29.5 C723.9,674.9,722.5,674.5,722.1,675.4L722.1,675.4z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M577.2,720.7c22-27.2,44.8-53.8,68.3-79.8c0.6-0.7-0.4-1.8-1.1-1.1c-23.5,25.9-46.3,52.5-68.3,79.8 C575.5,720.4,576.6,721.4,577.2,720.7L577.2,720.7z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M603.8,722.4c19.7-27.5,40.5-54.1,62.3-79.9c0.6-0.7-0.4-1.8-1.1-1.1c-21.9,25.9-42.7,52.6-62.5,80.2 C601.9,722.4,603.2,723.2,603.8,722.4L603.8,722.4z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M632.4,726.5c17.1-28.6,35.8-56.2,56-82.7c0.6-0.8-0.7-1.5-1.3-0.8c-20.2,26.5-38.9,54.1-56,82.7 C630.6,726.5,631.9,727.3,632.4,726.5L632.4,726.5z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M656.4,729c16.8-31.3,36.7-60.8,59.5-88c0.6-0.7-0.4-1.8-1.1-1.1c-22.9,27.3-42.9,56.9-59.8,88.3 C654.6,729.1,655.9,729.9,656.4,729L656.4,729z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M590,704.5c25.6-2.7,51.2,0.5,76.7,3.9c1,0.1,0.9-1.4,0-1.5c-25.4-3.4-51-6.7-76.7-3.9 C589.1,703.1,589.1,704.6,590,704.5L590,704.5z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M602.9,689.9c24.2-0.9,48.4,0.9,72.2,5.5c0.9,0.2,1.3-1.3,0.4-1.4c-23.9-4.6-48.3-6.4-72.6-5.5 C602,688.4,602,689.9,602.9,689.9L602.9,689.9z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M614.5,675.8c23.3-1.5,46.6,0.6,69.3,6.2c0.9,0.2,1.3-1.2,0.4-1.4c-22.8-5.7-46.2-7.8-69.7-6.3 C613.5,674.4,613.5,675.9,614.5,675.8L614.5,675.8z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M626.5,661.7c22.4,0.1,44.6,2.4,66.5,6.9c0.9,0.2,1.3-1.3,0.4-1.4c-22-4.5-44.4-6.8-66.9-6.9 C625.6,660.2,625.6,661.7,626.5,661.7L626.5,661.7z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M638.4,648.6c21.3,0.4,42.5,2.9,63.2,7.6c0.9,0.2,1.3-1.2,0.4-1.4c-20.9-4.7-42.2-7.3-63.6-7.6 C637.4,647.1,637.4,648.6,638.4,648.6L638.4,648.6z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M707,663.8c-9.8,14.4-19.5,28.8-29.3,43.2c-0.5,0.8,0.8,1.6,1.3,0.8c9.8-14.4,19.5-28.8,29.3-43.2 C708.9,663.7,707.6,663,707,663.8L707,663.8z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M541.4,642c12.5-5.3,26-2.3,39.2-2.5c11.1-0.1,21.7-3.2,31.2-8.8c0.8-0.5,0.1-1.8-0.8-1.3 c-11.7,6.9-24.1,9.1-37.5,8.5c-11.2-0.5-22.3-1.6-32.9,2.9C539.8,641.1,540.5,642.4,541.4,642L541.4,642z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M575.1,635.8c21.4-12.1,31.3-37.6,53.6-48.3c0.9-0.4,0.1-1.7-0.8-1.3c-22.4,10.8-32.2,36.2-53.6,48.3 C573.5,635,574.2,636.3,575.1,635.8L575.1,635.8z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M602.3,564.5c-3.7-2.9-3.1-7.6-1-11.3c1-1.8,2.5-3.7,4.2-4.8c3.1-2,6-0.4,8.4,1.7c0.7,0.6,1.8-0.4,1.1-1.1 c-5-4.2-9.7-3.8-13.8,1.6c-3.3,4.4-5,11,0,15C602,566.2,603.1,565.1,602.3,564.5L602.3,564.5z",
    style: {
      fill: "#191919"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "torso"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M910.3,491.4c-27.4,30.4-34.8,63.8-38.8,82.7c-7.3,35,0.4,49,0.9,115.5c0.2,28.3-1,51.2-1.9,65.6 c6.2,4.8,44.6,33.4,95.9,24c38-6.9,60.9-30.7,68.1-38.8c1.7-9.5,4.1-23.5,6.9-40.5c14.8-91.7,22.1-138.2,12.9-171.5 c-5.5-20.2-19.1-52.2-57.7-85.3C980.4,446.5,941.5,456.9,910.3,491.4z",
    style: {
      fill: "#EC615B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.2,473c9.5,28.4,14.6,52.7,17.6,70.5c7.9,47.1,19.8,117.7-13.7,186.1c-10.7,21.8-23.2,37.8-32,47.7 c11.6,2.7,34.6,6.4,62-0.7c32.6-8.4,53-27.3,61.4-35.9c6.5-37.2,11.7-69.1,15.7-94c6.9-43.8,8.5-57.1,7.8-75.8 c-0.8-24-1.9-49.2-16.3-76.4c-13.8-26-33.2-41.6-45.1-49.6c-9.7,1.7-23.4,5.3-37.9,13.7C949.7,463.4,943.2,468.5,938.2,473z",
    style: {
      opacity: 0.19,
      fill: "#6C6D6D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.8,520.7c-1.8,0.1,2,27.8-3.9,66c-10.9,70.7-45.9,119.7-59.4,137.1c-11.3,14.5-29,34.5-54.9,54.2 c9.3,1.4,21.7,2,35.9-0.7c33.7-6.3,55.1-27,63.3-35.9c2.1-12.2,5.5-31.3,9.8-54.9c10.1-55.2,12.1-61.8,13.7-79 C1060.7,560.6,1053.9,520.7,1051.8,520.7z",
    style: {
      opacity: 0.18,
      fill: "#6C6D6D"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand_l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M734.1,595c-1.9-1.3-5.7-3.7-5.3-5.7c0.8-3.2,12.3-3.7,20.6-2.3c5.6,0.9,15.8,3.8,26.5,13.9 C763.9,602.6,746.6,603.1,734.1,595z",
    style: {
      fill: "#FFFFFF",
      stroke: "#191919",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.4,499.2c-20.1-5.9-43.6,21.2-45.7,23.8c-8,9.5-9.9,16.3-17.4,34.7c-18.2,45-27.7,67.7-45.7,79.5 c-16.1,10.6-33,11-37.5,11c-18.9-0.1-34.5-9.5-64.9-28.3c-25.6-15.9-28.2-20.7-43-24.7c-7.5-2-29.5-8-46.6,3.7 c-10.9,7.4-17.6,21.2-14.6,24.7c3.8,4.5,24.2-6.1,24.3-5.7c0.1,0.2-5.9,1.9-11.3,6.7c-2.7,2.3-7.5,7.3-6.4,9.1 c2,3.4,20.2-12.2,36.4-6.4c11,3.9,11.6,14.4,24.5,18.5c7.6,2.4,14.8,1.1,19.4-0.2c6.2,9.3,16.7,22.6,32.9,34.7 c9.7,7.2,43.9,32,91.4,28.3c50.4-3.9,81-37.2,90.5-47.5c5.5-5.9,45.4-50.6,39.3-108.8C1041.1,542.8,1037.2,505.4,1016.4,499.2z",
    style: {
      fill: "#FFFFFF",
      stroke: "#191919",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.2,499.2c-7.6,2.5,1.9,29.6-5.8,65.1c-7.3,34.1-26.5,57.1-35.2,67.6c-11.7,14.1-27,32.5-53.1,41.9 c-35,12.6-74.3,3.7-100.6-12.8c-7.8-5-14.4-17.9-31.9-28c-7.6-4.4-13.7-6.6-21-9.3c-17.6-6.4-33.4-12.2-49.5-7.1 c-7.7,2.4-14.6,7-14.2,7.8c0.4,0.9,9.3-2,17.3-4.7c-10.7,10.1-12.7,13.2-12.2,14c0.6,0.8,3.8-1.3,11.3-3.9 c8.2-2.9,13.9-4.8,20.5-3.2c3.3,0.8,5.7,2.3,7.2,3.2c5.5,3.4,6.4,6.7,11.8,10.6c3.3,2.4,6.3,3.6,7.9,4.2c3.3,1.3,10.3,3.4,20.2,1.6 c6.8,9.8,38.3,53.2,93.6,61.2c28.5,4.1,51-2.9,59.9-5.8c48.8-15.8,73.5-53.6,79.9-64.1c19.8-32.4,33.3-83,12.9-119.4 C1028.4,509,1019.4,497.5,1014.2,499.2z",
    style: {
      opacity: 0.25,
      fill: "#6C6D6D"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M702.8,623.9c5.3-5.5,11.5-9.5,18.7-11.9c1.4-0.5,0.8-2.6-0.6-2.2c-7.5,2.6-14.2,6.8-19.7,12.5 C700.2,623.4,701.8,625,702.8,623.9L702.8,623.9z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M706.4,610.5c5.3-5.9,12.7-8.2,20.1-10.3c1.4-0.4,0.8-2.6-0.6-2.2c-7.7,2.3-15.5,4.8-21,10.9 C703.8,610,705.4,611.5,706.4,610.5L706.4,610.5z",
    style: {
      fill: "#191919"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1038.9,542.2c-3.4,10.4-8.9,25.4-17,42.8c-16.1,34.3-30.6,65.2-58.9,87.1c-34.9,27-76.7,29.3-100.2,28.2 c16.5,6.7,30.2,8.1,38.9,8.3c66.2,1.4,112.6-61.3,127-89.5c2.5-5,7.7-15.4,10.7-30.2C1043.3,569,1041,552.3,1038.9,542.2z",
    style: {
      opacity: 0.29,
      fill: "#6C6D6D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.4,626.3c5.6,3.9,13.5,8.5,23.6,12.1c8,2.8,15.3,4.2,21.1,4.9c-16.1,5.3-23.6,3.2-27.5,0 c-2.4-2-4.9-5.7-12.4-12.6C749.3,628.8,747.6,627.3,746.4,626.3z",
    style: {
      opacity: 0.26,
      fill: "#6C6D6D"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M861.4,297.5c-1.1,6.4-2.2,12.8-3.1,19.5c-3.9,27.2-5.5,52.9-5.6,76.8c5.5-0.6,10.9-1.2,16.4-1.7 c-0.6,5.3-2.3,24.7,10.1,43.9c11.7,18.1,28.5,24.7,33.7,26.5c-0.6,9.8-1.1,19.5-1.7,29.3c10.8-9.6,25.5-20.9,44.2-31 c14.3-7.7,27.8-13,39.3-16.6c-12.9-16-17.8-31.1-19.9-39.8c-3.6-15-2.9-27.9-2.2-39.3c0.7-11.7,2.4-21.4,3.9-28.2 c4.7-21.4-7.6-55.3-32.1-67.5C920.2,257.3,884.1,267.5,861.4,297.5z",
    style: {
      fill: "#FFFFFF",
      stroke: "#161616",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M866.8,392.8c2.8-0.4,5.7-0.7,8.5-1c1-0.1,1-1.6,0-1.5c-3,0.3-5.9,0.7-8.9,1.1 C865.5,391.4,865.9,392.9,866.8,392.8L866.8,392.8z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M957,313c-12.1,3.1-14.3,13.6-29.6,35.5c-15.5,22.2-25.3,36.1-42.8,44.2c-11.3,5.2-16.9,3.8-21.9,10.5 c-8.6,11.6-2.8,30.7,2.3,40.5c5.9,11.3,14.9,18.1,22.3,23.7c7.1,5.3,13.6,8.8,18.2,10.9c-4.9-7.5-5.2-9.8-4.6-10.5 c1.6-1.6,8.4,7,16.4,5.9c2.3-0.3,6.4-1.6,15.5-15.9c6.2-9.7,10.4-16.4,13.2-26c6.1-20.6-2.5-26.2,0-53.3 c0.4-4.1,3.2-36.2,14.6-38.3c4.1-0.8,8.3,2.6,10.3,5.2c4.2,5.5,3.7,14.3-1.5,21.9c1.7-1.2,18-12.2,17.8-30.1 c0-2.8-0.1-13.1-7.9-19.8C970.4,309.8,958,312.8,957,313z",
    style: {
      fill: "#161616",
      stroke: "#161616",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 876.4,
    cy: 351,
    rx: 4.2,
    ry: 7.5,
    style: {
      fill: "#161616"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 844.4,
    cy: 354.5,
    rx: 4.2,
    ry: 7.5,
    style: {
      fill: "#161616"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M838.1,342.2c2.7-3.1,6.9-3.4,9.9-0.4c1.4,1.4,3.5-0.8,2.1-2.1c-4.1-4-10.4-3.9-14.2,0.4 C834.8,341.6,836.9,343.7,838.1,342.2L838.1,342.2z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M870.9,337c3.5-2.9,8.1-2.5,11.1,0.8c1.3,1.4,3.4-0.7,2.1-2.1c-4.2-4.5-10.7-4.7-15.4-0.8 C867.3,336.1,869.4,338.2,870.9,337L870.9,337z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M858,309.4c1.1-7.2,3.9-19,11.6-31.2c2.7-4.3,8.5-13.4,17.7-19.6c17.6-11.7,44.7-10.8,64.4,3.6 c19.3,14.1,28.9,39.3,24.7,64.3C936.9,320.9,897.5,315.2,858,309.4z",
    style: {
      fill: "#5222D0"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M793.4,310.3c60.7,7.8,121.5,15.6,182.2,23.3c5.7,0.7,5.7-8.3,0-9c-60.7-7.8-121.5-15.6-182.2-23.3 C787.7,300.5,787.7,309.5,793.4,310.3L793.4,310.3z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M909.4,251.3c15.6,3.4,27.4,16,29.4,31.1c1.8,13.2-4,26.6-15,34.8c17.3,2.3,34.7,4.7,52,7 c0.9-4.6,1.7-11.6,0.6-19.8c-2.6-19.2-13.7-31.5-17.3-35.2c-3.9-4-17.7-17.4-38.2-18.6C916.2,250.4,912.2,250.8,909.4,251.3z",
    style: {
      fill: "#321693"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuyOnChair);
export default __webpack_public_path__ + "static/media/guy-on-chair.85affdbdb7834f65e5cd989a43a1b8c9.svg";
export { ForwardRef as ReactComponent };